/**
 * Theme palette configuration based on the current design
 * Extracted from existing HTML/CSS variables
 */

import { PaletteOptions } from '@mui/material/styles';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#4f46e5', // Indigo
    light: '#6366f1',
    dark: '#4338ca',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#06b6d4', // Cyan
    light: '#22d3ee',
    dark: '#0891b2',
    contrastText: '#ffffff',
  },
  background: {
    default: '#ffffff',
    paper: '#f8fafc', // Soft primary tint
  },
  text: {
    primary: '#0b1220',
    secondary: 'rgba(11, 18, 32, 0.62)',
  },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#8b5cf6', // Purple
    light: '#a78bfa',
    dark: '#7c3aed',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#34d399', // Emerald
    light: '#6ee7b7',
    dark: '#10b981',
    contrastText: '#ffffff',
  },
  background: {
    default: '#0b1220', // Deep navy
    paper: '#0f1724', // Elevated surface
  },
  text: {
    primary: '#eaf2fb',
    secondary: 'rgba(234, 241, 248, 0.62)',
  },
};
